import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DriveLayout } = await import('@containers/Drive/index');
    return {
        Component: DriveLayout,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
